// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"370":"7661fac7","715":"1cdf8e66"}[chunkId] + ".css";
};